import React from 'react';

import chevRightIcon from '../../../assets/images/chev-right-royal.svg';

const FormStepLink = (/** @type {import('./FormStepLinkTypes').FormStepLinkProps} */ { onClick, customStyles, href, children }) => {
  return (
    <a
      href={href && href}
      className='form-step__link form-step__link--right form-step__link--small'
      onClick={onClick}
      style={customStyles}
    >
      {children} <img src={chevRightIcon} />
    </a>
  );

};

export default FormStepLink;
